"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: lifecycle/lifecycle-milestone.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Flifecycle%2Flifecycle-milestone.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.milestoneStatusToJSON = exports.milestoneStatusFromJSON = exports.milestoneScopeToJSON = exports.milestoneScopeFromJSON = exports.milestoneGroupToJSON = exports.milestoneGroupFromJSON = exports.milestoneTypeToJSON = exports.milestoneTypeFromJSON = exports.MilestoneCta = exports.Milestone = exports.Cta = exports.MilestoneStatus = exports.MilestoneScope = exports.MilestoneGroup = exports.MilestoneType = void 0;
const lifecycle_action_1 = require("./lifecycle-action");
const protobufPackage = 'com.step.lifecycle.proto';
var MilestoneType;
(function (MilestoneType) {
    MilestoneType["INVALID_MILESTONE_TYPE"] = "INVALID_MILESTONE_TYPE";
    MilestoneType["ALLOWANCE_RECEIVED"] = "ALLOWANCE_RECEIVED";
    MilestoneType["ALLOWANCE_SETUP"] = "ALLOWANCE_SETUP";
    MilestoneType["CARD_USED"] = "CARD_USED";
    MilestoneType["CONTACT_JOINED_STEP"] = "CONTACT_JOINED_STEP";
    MilestoneType["EARLY_DIRECT_DEPOSIT_RECEIVED"] = "EARLY_DIRECT_DEPOSIT_RECEIVED";
    MilestoneType["FIRST_TRANSACTION_AGE"] = "FIRST_TRANSACTION_AGE";
    MilestoneType["FUNDING_RECEIVED"] = "FUNDING_RECEIVED";
    MilestoneType["FUNDING_AMOUNT_TOTAL"] = "FUNDING_AMOUNT_TOTAL";
    MilestoneType["GOT_SPONSORED"] = "GOT_SPONSORED";
    MilestoneType["GRADUATED"] = "GRADUATED";
    MilestoneType["OFFER_ACTIVATED_FIRST"] = "OFFER_ACTIVATED_FIRST";
    MilestoneType["OFFER_ACTIVATED"] = "OFFER_ACTIVATED";
    MilestoneType["OFFER_REWARD_RECEIVED"] = "OFFER_REWARD_RECEIVED";
    MilestoneType["OFFER_REWARD_AMOUNT_TOTAL"] = "OFFER_REWARD_AMOUNT_TOTAL";
    MilestoneType["PHYSICAL_CARD_ACTIVATED"] = "PHYSICAL_CARD_ACTIVATED";
    MilestoneType["REFERRAL_INVITE_SENT_TOTAL"] = "REFERRAL_INVITE_SENT_TOTAL";
    MilestoneType["REFERRAL_REWARD"] = "REFERRAL_REWARD";
    MilestoneType["REFERRAL_REWARD_AMOUNT_TOTAL"] = "REFERRAL_REWARD_AMOUNT_TOTAL";
    MilestoneType["SAVINGS_GOAL_ACHIEVED"] = "SAVINGS_GOAL_ACHIEVED";
    MilestoneType["P2P_SENT"] = "P2P_SENT";
    MilestoneType["P2P_SENT_NON_STEP_USERS_TOTAL"] = "P2P_SENT_NON_STEP_USERS_TOTAL";
    MilestoneType["P2P_RECEIVED"] = "P2P_RECEIVED";
    MilestoneType["ACCOUNT_PROGRESS_COMPLETED"] = "ACCOUNT_PROGRESS_COMPLETED";
    MilestoneType["BASIC_PROGRESS_COMPLETED"] = "BASIC_PROGRESS_COMPLETED";
    MilestoneType["NO_INTEREST_PROGRESS_COMPLETED"] = "NO_INTEREST_PROGRESS_COMPLETED";
    MilestoneType["BUILD_CREDIT_PROGRESS_COMPLETED"] = "BUILD_CREDIT_PROGRESS_COMPLETED";
    MilestoneType["BECOME_SPONSOR_PROGRESS_COMPLETED"] = "BECOME_SPONSOR_PROGRESS_COMPLETED";
    MilestoneType["TEST_MILESTONE"] = "TEST_MILESTONE";
    MilestoneType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MilestoneType || (exports.MilestoneType = MilestoneType = {}));
/**
 * Describes the class of a milestone.
 *
 * Milestones are grouped into classes, which then are used to define
 * the content of a push notification, e.g. "You reached a FUNDING milestone".
 */
var MilestoneGroup;
(function (MilestoneGroup) {
    MilestoneGroup["INVALID_MILESTONE_GROUP"] = "INVALID_MILESTONE_GROUP";
    MilestoneGroup["ACCOUNT"] = "ACCOUNT";
    MilestoneGroup["ACTIVITY"] = "ACTIVITY";
    MilestoneGroup["FINANCIAL"] = "FINANCIAL";
    MilestoneGroup["FUNDING"] = "FUNDING";
    MilestoneGroup["GENERAL"] = "GENERAL";
    MilestoneGroup["SOCIAL"] = "SOCIAL";
    MilestoneGroup["TEST_MILESTONE_GROUP"] = "TEST_MILESTONE_GROUP";
    MilestoneGroup["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MilestoneGroup || (exports.MilestoneGroup = MilestoneGroup = {}));
var MilestoneScope;
(function (MilestoneScope) {
    MilestoneScope["INVALID_MILESTONE_SCOPE"] = "INVALID_MILESTONE_SCOPE";
    MilestoneScope["POSITIVE_MOMENT"] = "POSITIVE_MOMENT";
    /**
     * ONBOARDING - Deprecated
     */
    MilestoneScope["ONBOARDING"] = "ONBOARDING";
    MilestoneScope["TEST_MILESTONE_SCOPE"] = "TEST_MILESTONE_SCOPE";
    MilestoneScope["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MilestoneScope || (exports.MilestoneScope = MilestoneScope = {}));
/**
 * Deprecated, Milestones do not have a status anymore and if created are
 * assumed completed.
 */
var MilestoneStatus;
(function (MilestoneStatus) {
    MilestoneStatus["INVALID_MILESTONE_STATUS"] = "INVALID_MILESTONE_STATUS";
    MilestoneStatus["READY"] = "READY";
    MilestoneStatus["PENDING"] = "PENDING";
    MilestoneStatus["COMPLETED"] = "COMPLETED";
    MilestoneStatus["FAILED"] = "FAILED";
    MilestoneStatus["LOCKED"] = "LOCKED";
    MilestoneStatus["SKIPPED"] = "SKIPPED";
    MilestoneStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MilestoneStatus || (exports.MilestoneStatus = MilestoneStatus = {}));
function createBaseCta() {
    return {
        id: '',
        action: lifecycle_action_1.Action.INVALID_ACTION,
        title: '',
        content: '',
        enabled: false,
        critical: false,
    };
}
exports.Cta = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            action: isSet(object.action) ? (0, lifecycle_action_1.actionFromJSON)(object.action) : lifecycle_action_1.Action.INVALID_ACTION,
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            content: isSet(object.content) ? globalThis.String(object.content) : '',
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
            critical: isSet(object.critical) ? globalThis.Boolean(object.critical) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.action !== lifecycle_action_1.Action.INVALID_ACTION) {
            obj.action = (0, lifecycle_action_1.actionToJSON)(message.action);
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.content !== '') {
            obj.content = message.content;
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        if (message.critical !== false) {
            obj.critical = message.critical;
        }
        return obj;
    },
    create(base) {
        return exports.Cta.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCta();
        message.id = object.id ?? '';
        message.action = object.action ?? lifecycle_action_1.Action.INVALID_ACTION;
        message.title = object.title ?? '';
        message.content = object.content ?? '';
        message.enabled = object.enabled ?? false;
        message.critical = object.critical ?? false;
        return message;
    },
};
function createBaseMilestone() {
    return {
        id: '',
        type: MilestoneType.INVALID_MILESTONE_TYPE,
        scope: MilestoneScope.INVALID_MILESTONE_SCOPE,
        status: MilestoneStatus.INVALID_MILESTONE_STATUS,
    };
}
exports.Milestone = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            type: isSet(object.type)
                ? milestoneTypeFromJSON(object.type)
                : MilestoneType.INVALID_MILESTONE_TYPE,
            status: isSet(object.status)
                ? milestoneStatusFromJSON(object.status)
                : MilestoneStatus.INVALID_MILESTONE_STATUS,
        };
        if (isSet(object.scope)) {
            message.scope = milestoneScopeFromJSON(object.scope);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.type !== MilestoneType.INVALID_MILESTONE_TYPE) {
            obj.type = milestoneTypeToJSON(message.type);
        }
        if (message.scope !== undefined && message.scope !== MilestoneScope.INVALID_MILESTONE_SCOPE) {
            obj.scope = milestoneScopeToJSON(message.scope);
        }
        if (message.status !== MilestoneStatus.INVALID_MILESTONE_STATUS) {
            obj.status = milestoneStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.Milestone.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMilestone();
        message.id = object.id ?? '';
        message.type = object.type ?? MilestoneType.INVALID_MILESTONE_TYPE;
        message.scope = object.scope ?? MilestoneScope.INVALID_MILESTONE_SCOPE;
        message.status = object.status ?? MilestoneStatus.INVALID_MILESTONE_STATUS;
        return message;
    },
};
function createBaseMilestoneCta() {
    return { cta: undefined, milestone: undefined };
}
exports.MilestoneCta = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.cta)) {
            message.cta = exports.Cta.fromJSON(object.cta);
        }
        if (isSet(object.milestone)) {
            message.milestone = exports.Milestone.fromJSON(object.milestone);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cta !== undefined) {
            obj.cta = exports.Cta.toJSON(message.cta);
        }
        if (message.milestone !== undefined) {
            obj.milestone = exports.Milestone.toJSON(message.milestone);
        }
        return obj;
    },
    create(base) {
        return exports.MilestoneCta.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMilestoneCta();
        message.cta = (object.cta !== undefined && object.cta !== null)
            ? exports.Cta.fromPartial(object.cta)
            : undefined;
        message.milestone = (object.milestone !== undefined && object.milestone !== null)
            ? exports.Milestone.fromPartial(object.milestone)
            : undefined;
        return message;
    },
};
function milestoneTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MILESTONE_TYPE':
            return MilestoneType.INVALID_MILESTONE_TYPE;
        case 1:
        case 'ALLOWANCE_RECEIVED':
            return MilestoneType.ALLOWANCE_RECEIVED;
        case 2:
        case 'ALLOWANCE_SETUP':
            return MilestoneType.ALLOWANCE_SETUP;
        case 3:
        case 'CARD_USED':
            return MilestoneType.CARD_USED;
        case 4:
        case 'CONTACT_JOINED_STEP':
            return MilestoneType.CONTACT_JOINED_STEP;
        case 5:
        case 'EARLY_DIRECT_DEPOSIT_RECEIVED':
            return MilestoneType.EARLY_DIRECT_DEPOSIT_RECEIVED;
        case 6:
        case 'FIRST_TRANSACTION_AGE':
            return MilestoneType.FIRST_TRANSACTION_AGE;
        case 7:
        case 'FUNDING_RECEIVED':
            return MilestoneType.FUNDING_RECEIVED;
        case 8:
        case 'FUNDING_AMOUNT_TOTAL':
            return MilestoneType.FUNDING_AMOUNT_TOTAL;
        case 9:
        case 'GOT_SPONSORED':
            return MilestoneType.GOT_SPONSORED;
        case 10:
        case 'GRADUATED':
            return MilestoneType.GRADUATED;
        case 22:
        case 'OFFER_ACTIVATED_FIRST':
            return MilestoneType.OFFER_ACTIVATED_FIRST;
        case 11:
        case 'OFFER_ACTIVATED':
            return MilestoneType.OFFER_ACTIVATED;
        case 12:
        case 'OFFER_REWARD_RECEIVED':
            return MilestoneType.OFFER_REWARD_RECEIVED;
        case 13:
        case 'OFFER_REWARD_AMOUNT_TOTAL':
            return MilestoneType.OFFER_REWARD_AMOUNT_TOTAL;
        case 14:
        case 'PHYSICAL_CARD_ACTIVATED':
            return MilestoneType.PHYSICAL_CARD_ACTIVATED;
        case 15:
        case 'REFERRAL_INVITE_SENT_TOTAL':
            return MilestoneType.REFERRAL_INVITE_SENT_TOTAL;
        case 16:
        case 'REFERRAL_REWARD':
            return MilestoneType.REFERRAL_REWARD;
        case 17:
        case 'REFERRAL_REWARD_AMOUNT_TOTAL':
            return MilestoneType.REFERRAL_REWARD_AMOUNT_TOTAL;
        case 18:
        case 'SAVINGS_GOAL_ACHIEVED':
            return MilestoneType.SAVINGS_GOAL_ACHIEVED;
        case 19:
        case 'P2P_SENT':
            return MilestoneType.P2P_SENT;
        case 20:
        case 'P2P_SENT_NON_STEP_USERS_TOTAL':
            return MilestoneType.P2P_SENT_NON_STEP_USERS_TOTAL;
        case 21:
        case 'P2P_RECEIVED':
            return MilestoneType.P2P_RECEIVED;
        case 23:
        case 'ACCOUNT_PROGRESS_COMPLETED':
            return MilestoneType.ACCOUNT_PROGRESS_COMPLETED;
        case 24:
        case 'BASIC_PROGRESS_COMPLETED':
            return MilestoneType.BASIC_PROGRESS_COMPLETED;
        case 25:
        case 'NO_INTEREST_PROGRESS_COMPLETED':
            return MilestoneType.NO_INTEREST_PROGRESS_COMPLETED;
        case 26:
        case 'BUILD_CREDIT_PROGRESS_COMPLETED':
            return MilestoneType.BUILD_CREDIT_PROGRESS_COMPLETED;
        case 27:
        case 'BECOME_SPONSOR_PROGRESS_COMPLETED':
            return MilestoneType.BECOME_SPONSOR_PROGRESS_COMPLETED;
        case 99:
        case 'TEST_MILESTONE':
            return MilestoneType.TEST_MILESTONE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MilestoneType.UNRECOGNIZED;
    }
}
exports.milestoneTypeFromJSON = milestoneTypeFromJSON;
function milestoneTypeToJSON(object) {
    switch (object) {
        case MilestoneType.INVALID_MILESTONE_TYPE:
            return 'INVALID_MILESTONE_TYPE';
        case MilestoneType.ALLOWANCE_RECEIVED:
            return 'ALLOWANCE_RECEIVED';
        case MilestoneType.ALLOWANCE_SETUP:
            return 'ALLOWANCE_SETUP';
        case MilestoneType.CARD_USED:
            return 'CARD_USED';
        case MilestoneType.CONTACT_JOINED_STEP:
            return 'CONTACT_JOINED_STEP';
        case MilestoneType.EARLY_DIRECT_DEPOSIT_RECEIVED:
            return 'EARLY_DIRECT_DEPOSIT_RECEIVED';
        case MilestoneType.FIRST_TRANSACTION_AGE:
            return 'FIRST_TRANSACTION_AGE';
        case MilestoneType.FUNDING_RECEIVED:
            return 'FUNDING_RECEIVED';
        case MilestoneType.FUNDING_AMOUNT_TOTAL:
            return 'FUNDING_AMOUNT_TOTAL';
        case MilestoneType.GOT_SPONSORED:
            return 'GOT_SPONSORED';
        case MilestoneType.GRADUATED:
            return 'GRADUATED';
        case MilestoneType.OFFER_ACTIVATED_FIRST:
            return 'OFFER_ACTIVATED_FIRST';
        case MilestoneType.OFFER_ACTIVATED:
            return 'OFFER_ACTIVATED';
        case MilestoneType.OFFER_REWARD_RECEIVED:
            return 'OFFER_REWARD_RECEIVED';
        case MilestoneType.OFFER_REWARD_AMOUNT_TOTAL:
            return 'OFFER_REWARD_AMOUNT_TOTAL';
        case MilestoneType.PHYSICAL_CARD_ACTIVATED:
            return 'PHYSICAL_CARD_ACTIVATED';
        case MilestoneType.REFERRAL_INVITE_SENT_TOTAL:
            return 'REFERRAL_INVITE_SENT_TOTAL';
        case MilestoneType.REFERRAL_REWARD:
            return 'REFERRAL_REWARD';
        case MilestoneType.REFERRAL_REWARD_AMOUNT_TOTAL:
            return 'REFERRAL_REWARD_AMOUNT_TOTAL';
        case MilestoneType.SAVINGS_GOAL_ACHIEVED:
            return 'SAVINGS_GOAL_ACHIEVED';
        case MilestoneType.P2P_SENT:
            return 'P2P_SENT';
        case MilestoneType.P2P_SENT_NON_STEP_USERS_TOTAL:
            return 'P2P_SENT_NON_STEP_USERS_TOTAL';
        case MilestoneType.P2P_RECEIVED:
            return 'P2P_RECEIVED';
        case MilestoneType.ACCOUNT_PROGRESS_COMPLETED:
            return 'ACCOUNT_PROGRESS_COMPLETED';
        case MilestoneType.BASIC_PROGRESS_COMPLETED:
            return 'BASIC_PROGRESS_COMPLETED';
        case MilestoneType.NO_INTEREST_PROGRESS_COMPLETED:
            return 'NO_INTEREST_PROGRESS_COMPLETED';
        case MilestoneType.BUILD_CREDIT_PROGRESS_COMPLETED:
            return 'BUILD_CREDIT_PROGRESS_COMPLETED';
        case MilestoneType.BECOME_SPONSOR_PROGRESS_COMPLETED:
            return 'BECOME_SPONSOR_PROGRESS_COMPLETED';
        case MilestoneType.TEST_MILESTONE:
            return 'TEST_MILESTONE';
        case MilestoneType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.milestoneTypeToJSON = milestoneTypeToJSON;
function milestoneGroupFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MILESTONE_GROUP':
            return MilestoneGroup.INVALID_MILESTONE_GROUP;
        case 1:
        case 'ACCOUNT':
            return MilestoneGroup.ACCOUNT;
        case 2:
        case 'ACTIVITY':
            return MilestoneGroup.ACTIVITY;
        case 3:
        case 'FINANCIAL':
            return MilestoneGroup.FINANCIAL;
        case 4:
        case 'FUNDING':
            return MilestoneGroup.FUNDING;
        case 5:
        case 'GENERAL':
            return MilestoneGroup.GENERAL;
        case 6:
        case 'SOCIAL':
            return MilestoneGroup.SOCIAL;
        case 99:
        case 'TEST_MILESTONE_GROUP':
            return MilestoneGroup.TEST_MILESTONE_GROUP;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MilestoneGroup.UNRECOGNIZED;
    }
}
exports.milestoneGroupFromJSON = milestoneGroupFromJSON;
function milestoneGroupToJSON(object) {
    switch (object) {
        case MilestoneGroup.INVALID_MILESTONE_GROUP:
            return 'INVALID_MILESTONE_GROUP';
        case MilestoneGroup.ACCOUNT:
            return 'ACCOUNT';
        case MilestoneGroup.ACTIVITY:
            return 'ACTIVITY';
        case MilestoneGroup.FINANCIAL:
            return 'FINANCIAL';
        case MilestoneGroup.FUNDING:
            return 'FUNDING';
        case MilestoneGroup.GENERAL:
            return 'GENERAL';
        case MilestoneGroup.SOCIAL:
            return 'SOCIAL';
        case MilestoneGroup.TEST_MILESTONE_GROUP:
            return 'TEST_MILESTONE_GROUP';
        case MilestoneGroup.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.milestoneGroupToJSON = milestoneGroupToJSON;
function milestoneScopeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MILESTONE_SCOPE':
            return MilestoneScope.INVALID_MILESTONE_SCOPE;
        case 1:
        case 'POSITIVE_MOMENT':
            return MilestoneScope.POSITIVE_MOMENT;
        case 2:
        case 'ONBOARDING':
            return MilestoneScope.ONBOARDING;
        case 99:
        case 'TEST_MILESTONE_SCOPE':
            return MilestoneScope.TEST_MILESTONE_SCOPE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MilestoneScope.UNRECOGNIZED;
    }
}
exports.milestoneScopeFromJSON = milestoneScopeFromJSON;
function milestoneScopeToJSON(object) {
    switch (object) {
        case MilestoneScope.INVALID_MILESTONE_SCOPE:
            return 'INVALID_MILESTONE_SCOPE';
        case MilestoneScope.POSITIVE_MOMENT:
            return 'POSITIVE_MOMENT';
        case MilestoneScope.ONBOARDING:
            return 'ONBOARDING';
        case MilestoneScope.TEST_MILESTONE_SCOPE:
            return 'TEST_MILESTONE_SCOPE';
        case MilestoneScope.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.milestoneScopeToJSON = milestoneScopeToJSON;
function milestoneStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MILESTONE_STATUS':
            return MilestoneStatus.INVALID_MILESTONE_STATUS;
        case 1:
        case 'READY':
            return MilestoneStatus.READY;
        case 2:
        case 'PENDING':
            return MilestoneStatus.PENDING;
        case 3:
        case 'COMPLETED':
            return MilestoneStatus.COMPLETED;
        case 4:
        case 'FAILED':
            return MilestoneStatus.FAILED;
        case 5:
        case 'LOCKED':
            return MilestoneStatus.LOCKED;
        case 6:
        case 'SKIPPED':
            return MilestoneStatus.SKIPPED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MilestoneStatus.UNRECOGNIZED;
    }
}
exports.milestoneStatusFromJSON = milestoneStatusFromJSON;
function milestoneStatusToJSON(object) {
    switch (object) {
        case MilestoneStatus.INVALID_MILESTONE_STATUS:
            return 'INVALID_MILESTONE_STATUS';
        case MilestoneStatus.READY:
            return 'READY';
        case MilestoneStatus.PENDING:
            return 'PENDING';
        case MilestoneStatus.COMPLETED:
            return 'COMPLETED';
        case MilestoneStatus.FAILED:
            return 'FAILED';
        case MilestoneStatus.LOCKED:
            return 'LOCKED';
        case MilestoneStatus.SKIPPED:
            return 'SKIPPED';
        case MilestoneStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.milestoneStatusToJSON = milestoneStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=lifecycle-milestone.js.map